import styled from '@emotion/styled';

export const BetaSuggestionModalWrapper = styled.div`
    box-sizing: border-box;
    position: absolute;
    top: 0px;
    left: 0;
    z-index: 500;
    box-shadow: 0px 1px 20px 0px #00000029;
`;

export const BetaSuggestionModalBody = styled.div`
    background: #f7f8fd;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
`;

export const CloseButton = styled.button`
    border-radius: 50%;
    width: 26px;
    height: 26px;
    background-color: #ffffff;
    border: none;
    position: absolute;
    right: 20px;
    top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    &:focus-visible {
        outline: 4px solid #b2d9f7;
        outline-offset: 0;
    }
`;

export const ModalBody = styled.div`
    padding: 25px 72px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const MainTitle = styled.div`
    font-family: GreycliffCF;
    font-weight: 700;
    font-size: 33px;
    line-height: 40px;
    color: #0972ed;
    margin-bottom: 10px;
    text-align: center;
`;

export const Description = styled.div`
    font-family: GreycliffCF;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #000000;
    text-align: center;
    margin-bottom: 25px;
`;
export const BetaButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 60px;
`;

export const BetaButtonStyles = {
    height: '42px !important',
    minWidth: '265px',
    fontSize: '16px !important',
    lineHeight: '20px !important',

    '&:focus-visible': {
        outline: '4px solid #007FE64D',
        outlineOffset: '0px',
    },
};

export const CurrentButtonStyles = {
    height: '36px !important',
    fontSize: '12px !important',
    lineHeight: '16px !important',
    whiteSpace: 'nowrap',
    '&:focus-visible': {
        outline: '4px solid #007FE64D',
        outlineOffset: '0px',
    },
};
export const FeaturesWrapper = styled.div`
    padding: 26px 55px 40px;
    border: 1px solid #a3a3a3;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 9px;
    position: relative;
    margin-bottom: 38px;
`;

export const FeaturesTitle = styled.div`
    font-family: GreycliffCF;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #000000;
`;

export const FeaturesListWrapper = styled.div`
    display: flex;
    align-content: center;
    gap: 5px;
`;

export const Feature = styled.div`
    font-family: GreycliffCF;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const ClassicBuildButtonWrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    padding: 0 20px;
    background: #f7f8fd;
    z-index: 2;
`;

export const CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
`;

export const CheckBoxLabel = styled.p`
    margin: 0;
    font-family: GreycliffCF;
    color: #000000;
    outline: 0;
    font-weight: 500;
    font-size: 11px;
    line-height: 15px;
    letter-spacing: 0%;
`;

export const ComingSoonWrapper = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(-12px, -26px);
    padding: 12px 12px 18px;
    background: #f7f8fd;
`;

export const ComingSoonLabel = styled.div`
    font-family: GreycliffCF;
    font-weight: 900;
    font-size: 11px;
    line-height: 10px;
    background-color: #6ef3d6;
    border-radius: 4px 14px 14px 0;
    height: 24px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #000000;
    padding: 7px 18px 7px 9px;
`;

export const ComingSoonLabelTriangle = styled.div`
    background-color: #6ef3d6;
    width: 10px;
    height: 10px;
    clip-path: polygon(0 0, 0% 100%, 100% 0);
    position: absolute;
    top: 36px;
`;

export const ComingSoonText = styled.span`
    padding-bottom: 1px;
`;

export const AnnounceIconWrapper = styled.div`
    transform: rotate(-8deg);
`;
